(function () {
  var gate = window.PupfordRevLiftOfferGate = window.PupfordRevLiftOfferGate || {};
  var CONTROL_SELECTOR = [
    '[data-revlift-offer-gated]',
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] input[type="submit"]',
    '[data-type="add-to-cart-form"] button[type="submit"]',
    '[data-type="add-to-cart-form"] input[type="submit"]',
    '.pf-product-form button[type="submit"]',
    '.pf-product-form [data-pf-type^="ProductATC"]',
    'button[name="add"]',
    '.product-form__submit',
    '[data-add-to-cart]',
    '[data-offer-v2-atc]',
    '[data-offer-v2-promo-atc]',
    '[data-offer-atc]',
    '[data-offer-buy-now]',
    '[data-buybox-cta]',
    '[data-bundle-page-add]',
    '#buyNowButton',
    '[href*="/cart/add"]',
    '.shopify-payment-button__button'
  ].join(', ');
  var CHECK_INTERVAL_MS = 50;
  var loadingStartedAt = Date.now();
  var timer = null;
  var refreshRequestedAt = 0;
  var refreshRequestGeneration = -1;

  gate.ready = false;
  document.documentElement.setAttribute('data-revlift-offers-pending', 'true');

  function normalizePath(path) {
    var value = String(path || '/').replace(/\/+$/, '');
    return value || '/';
  }

  function globalConfigIsReady() {
    try {
      if (!window.sessionStorage) return false;
      var key = 'revlift:config:non-b2b-default:' + String(Boolean(window.REVLIFT_IS_B2B)) + ':' + String(window.REVLIFT_COUNTRY_CODE || '') + ':';
      var keys = [key];
      // The offer app versions its global cache separately from product caches.
      for (var index = 0; index < window.sessionStorage.length; index++) {
        var candidate = window.sessionStorage.key(index);
        if (candidate && candidate.indexOf(key) === 0 && /^:visibility-v\d+$/.test(candidate.slice(key.length))) {
          keys.push(candidate);
        }
      }
      return keys.some(function (cacheKey) {
        try {
          var stored = JSON.parse(window.sessionStorage.getItem(cacheKey));
          return Boolean(stored && stored.payload && stored.payload.config &&
            Date.now() - Number(stored.storedAt || 0) < 60000);
        } catch (error) {
          return false;
        }
      });
    } catch (error) {
      return false;
    }
  }

  function currentPageMatch() {
    var debug = window.DiscountsAppDebug;
    var match = debug && debug.lastPageOfferMatch;
    if (!match || !Array.isArray(match.activeIds)) return null;

    var current = (
      normalizePath(match.path) === normalizePath(window.location.pathname) &&
      String(match.search || '') === String(window.location.search || '')
    );
    return current ? match : null;
  }

  function requestGlobalConfigSync() {
    refreshRequestedAt = Date.now();
    refreshRequestGeneration = Number(gate.configRequestGeneration || 0);
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { source: 'pupford-revlift-readiness' }
    }));
  }

  function currentPageOffersAreReady() {
    var match = currentPageMatch();
    var pendingConfigRequests = Number(gate.configRequestsPending || 0);
    var configGeneration = Number(gate.configRequestGeneration || 0);
    if (!globalConfigIsReady() || !match || pendingConfigRequests > 0) return false;

    var needsRefresh = (
      !refreshRequestedAt ||
      refreshRequestGeneration !== configGeneration ||
      Date.now() - refreshRequestedAt > 3000
    );
    var syncMarkers = window.DiscountsAppDebug && window.DiscountsAppDebug.lastSyncMarkers;
    var syncMarkersAt = Date.parse(String((syncMarkers && syncMarkers.at) || '')) || 0;
    if (syncMarkersAt >= refreshRequestedAt && refreshRequestedAt > 0 && !needsRefresh) {
      return true;
    }

    if (needsRefresh) requestGlobalConfigSync();
    return false;
  }

  function controls(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var found = Array.prototype.slice.call(scope.querySelectorAll(CONTROL_SELECTOR));
    if (root && root.matches && root.matches(CONTROL_SELECTOR)) found.unshift(root);
    return found.filter(function (control, index, list) {
      return list.indexOf(control) === index;
    });
  }

  function rememberOriginalState(control) {
    if (control.hasAttribute('data-revlift-originally-disabled')) return;

    var explicitlyGated = control.hasAttribute('data-revlift-offer-gated');
    var inventoryDisabled = control.hasAttribute('data-out-in-stock');
    var originallyDisabled = inventoryDisabled || (!explicitlyGated && !!control.disabled);
    control.setAttribute('data-revlift-originally-disabled', originallyDisabled ? 'true' : 'false');
  }

  function lockControl(control) {
    rememberOriginalState(control);
    control.setAttribute('data-revlift-offer-gated', '');
    if (!control.disabled) control.disabled = true;
    if (!control.hasAttribute('disabled')) control.setAttribute('disabled', '');
    if (control.getAttribute('aria-busy') !== 'true') control.setAttribute('aria-busy', 'true');
    if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
  }

  function restoreControlLabel(control) {
    var label = String(control.getAttribute('data-revlift-ready-label') || '').trim();
    var labelNode = control.querySelector && control.querySelector('span');
    if (label && labelNode) labelNode.textContent = label;
  }

  function shouldRemainDisabled(control) {
    if (control.getAttribute('data-revlift-originally-disabled') === 'true') return true;

    if (control.hasAttribute('data-sticky-atc')) {
      var sectionSuffix = String(control.id || '').replace(/^StickySubmitButton-/, '');
      var mainButton = sectionSuffix
        ? document.getElementById('ProductSubmitButton-' + sectionSuffix)
        : document.querySelector('[id^="ProductSubmitButton-"]');
      if (mainButton && mainButton.getAttribute('data-revlift-originally-disabled') === 'true') {
        return true;
      }
    }

    return false;
  }

  function unlockControl(control) {
    restoreControlLabel(control);
    control.setAttribute('data-revlift-offer-ready', 'true');
    control.removeAttribute('data-revlift-offer-gated');
    control.removeAttribute('aria-busy');

    if (shouldRemainDisabled(control)) {
      control.disabled = true;
      control.setAttribute('disabled', '');
      control.setAttribute('aria-disabled', 'true');
      return;
    }

    control.disabled = false;
    control.removeAttribute('disabled');
    control.setAttribute('aria-disabled', 'false');
    control.classList.remove('disabled');
  }

  function processControls(root) {
    controls(root).forEach(function (control) {
      if (gate.ready) unlockControl(control);
      else lockControl(control);
    });
  }

  // Dynamic builders own selection/inventory/loading state. Keep that state
  // separate from the temporary offer gate, including its accessible styling.
  gate.setControlDisabled = function (control, disabled) {
    if (!control) return;
    control.setAttribute('data-revlift-originally-disabled', disabled ? 'true' : 'false');
    if (gate.ready) unlockControl(control);
    else lockControl(control);
  };

  function unlockPage() {
    gate.ready = true;
    gate.readyAt = new Date().toISOString();
    if (timer) window.clearInterval(timer);
    timer = null;

    processControls(document);
    document.documentElement.removeAttribute('data-revlift-offers-pending');
    document.documentElement.setAttribute('data-revlift-offers-ready', 'true');
    document.dispatchEvent(new CustomEvent('pupford:revlift-offers-ready', {
      detail: {
        path: window.location.pathname,
        waitMs: Date.now() - loadingStartedAt
      }
    }));
  }

  function checkReadiness() {
    if (currentPageOffersAreReady()) {
      unlockPage();
      return;
    }
    processControls(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        if (node && node.nodeType === 1) processControls(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  processControls(document);
  checkReadiness();
  if (!gate.ready) timer = window.setInterval(checkReadiness, CHECK_INTERVAL_MS);
})();
